module.exports = __webpack_public_path__ + "img/ordnung.2f528bc5.webp";